import { useSiteConfig } from '../../context/SiteConfigContext';
import styles from './Footer.module.css';

function Footer() {
  const config = useSiteConfig();

  return (
    <footer className={styles.footer}>
      <div className={styles.divider} />
      <div className={styles.content}>
        <span className={styles.brand}>{config.sidebar.footerText}</span>
      </div>
    </footer>
  );
}

export default Footer;
